import { render, staticRenderFns } from "./BasicVideo.vue?vue&type=template&id=a36f2e4e&scoped=true"
import script from "./BasicVideo.vue?vue&type=script&lang=js"
export * from "./BasicVideo.vue?vue&type=script&lang=js"
import style0 from "./BasicVideo.vue?vue&type=style&index=0&id=a36f2e4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36f2e4e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicImage: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicImage.vue').default})
